import type { CreateSocietyInput } from '@idc-forms/schemas'
import { useSidePanelStore } from '@/shared/store/side-panel.store'
import { useCreateSocietyMutation } from '../hooks/use-society-mutations'
import { SocietyForm, type SocietyFormValues } from './society-form'

type SocietyCreatePanelProps = {
  onDone?: () => void
}

/** "Nueva sociedad" dentro del side panel: el mismo SocietyForm que la edición. */
export function SocietyCreatePanel({ onDone }: SocietyCreatePanelProps) {
  const closePanel = useSidePanelStore((s) => s.closePanel)
  const createMutation = useCreateSocietyMutation()
  const done = onDone ?? closePanel

  const handleSubmit = (values: SocietyFormValues) => {
    // En modo create el resolver ya garantizó las credenciales (schema completo).
    createMutation.mutate(values as CreateSocietyInput, {
      onSuccess: () => {
        done()
      }
    })
  }

  return (
    <SocietyForm
      mode="create"
      submitLabel="Crear sociedad"
      pending={createMutation.isPending}
      onSubmit={handleSubmit}
      onCancel={done}
    />
  )
}
